
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';

type VisaType = 'all' | 'visa_free' | 'visa_on_arrival' | 'e_visa' | 'visa_required';

interface VisaRequirementsFilterProps {
  onFilterChange: (visaType: VisaType) => void;
  currentFilter: VisaType;
}

export const VisaRequirementsFilter = ({
  onFilterChange,
  currentFilter,
}: VisaRequirementsFilterProps) => {
  return (
    <div className="mb-4">
      <Label htmlFor="visa-type-filter" className="mb-2 block">
        Filter by Visa Type
      </Label>
      <Select value={currentFilter} onValueChange={(value: VisaType) => onFilterChange(value)}>
        <SelectTrigger id="visa-type-filter" className="w-full">
          <SelectValue placeholder="Select visa type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Types</SelectItem>
          <SelectItem value="visa_free">Visa Free</SelectItem>
          <SelectItem value="visa_on_arrival">Visa on Arrival</SelectItem>
          <SelectItem value="e_visa">E-Visa</SelectItem>
          <SelectItem value="visa_required">Visa Required</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
